import React from "react";
import { SelectCheckbox } from "components/common/SelectCheckbox";

interface SettingItemProps {
  label: string;
  checked: boolean;
  onChange: (value: boolean) => void;
}

export const SettingItem: React.FC<SettingItemProps> = ({
  label,
  checked,
  onChange,
}) => {
  return (
    <div className="flex items-center justify-between">
      <label className="text-fg-muted-medium flex-1">{label}</label>
      <Checkbox checked={checked} onChange={onChange} />
    </div>
  );
};

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const Checkbox: React.FC<CheckboxProps> = ({ checked, onChange }) => {
  return (
    <SelectCheckbox
      selected={checked}
      onToggle={(e) => {
        e.stopPropagation();
        onChange(!checked);
      }}
    />
  );
};
